import React from "react";

const Boban = () => {
    return (
        <div className="pplban"> </div>
    )
}


export default Boban;